import { render, staticRenderFns } from "./GroupedMotions.vue?vue&type=template&id=d0673a48&scoped=true&"
import script from "./GroupedMotions.vue?vue&type=script&lang=js&"
export * from "./GroupedMotions.vue?vue&type=script&lang=js&"
import style0 from "./GroupedMotions.vue?vue&type=style&index=0&id=d0673a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0673a48",
  null
  
)

export default component.exports